import * as Icon from "@ant-design/icons";
import { Form, Col, Row, Select, Image, DatePicker, DatePickerProps, Modal, Flex } from "antd";
import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import { useEffect } from "react";
import { setIdEmpresaPermissao, setTitle } from "../../redux/slices/configuracoes/configuracoesSlice";
import { currencyBRL } from "../../util/dinheiroBRAuxiliar";
import { useAppSelector, useAppDispatch } from "../../util/hooks";
import { buscarEmpresa } from "../../services/empresaService";
import {
  setBuscaLancamentoControleAporte,
  setEntityLancamentoControleAporte,
  setModalCadastrarLancamentoControleAporte,
  setModalDeletarLancamentoControleAporte,
  setModalRecebimentoLancamentoControleAporte,
} from "../../redux/slices/lancamentoControleAporte/lancamentoControleAporteSlice";
import { buscarTipoLancamentoControleAporte } from "../../services/tipoLancamentoControleAporteService";
import { buscarLancamentoControleAporte, deletarLancamentoControleAporte } from "../../services/lancamentoControleAporteService";
import { LancamentoControleAporteModel } from "../../models/lancamentoControleAporte/lancamentoControleAporteModel";
import CadastroLancamentoControleAporte from "./modals/cadastrar";
import { listarSorteio } from "../../services/sorteioService";
import { DetalhesSorteioModel } from "../../models/sorteio/detalhesSorteioModel";
import { EmpresaModel } from "../../models/empresa/empresaModel";
import ConfirmarRecebimento from "./modals/recebimento";
import BuscarLancamentoControleAporteModel from "../../models/lancamentoControleAporte/chamadas/buscarLancamentoControleAporteModel";
import TableComponent from "../../components/table/tableComponent";
import AcoesComponent from "../../components/table/acoesComponent";
import { ItemMenuAcoes } from "../../models/sistema/itemMenuAcoes";
import MensagemModal from "../../components/modal/mensagem";
import { ButtonComponent } from "../../components/button/cadastrar";

dayjs.locale("pt-br");

const LancamentoControleAporte = () => {
  //estados globais
  const empresaState = useAppSelector((state) => state.empresa);
  const tipoLancamentoControleAporteState = useAppSelector((state) => state.tipoLancamentoControleAporte);
  const lancamentoControleAporteState = useAppSelector((state) => state.lancamentoControleAporte);
  const sorteioState = useAppSelector((state) => state.sorteio);
  const persistedState = useAppSelector((state) => state.persisted);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();

  const editar = Object.values(lancamentoControleAporteState.entity).length !== 0;

  useEffect(() => {
    dispatch(setTitle("CONTROLE DE APORTES"));
    if (empresaState.list.length === 0) dispatch(buscarEmpresa(empresaState.busca));
    if (tipoLancamentoControleAporteState.list.length === 0) dispatch(buscarTipoLancamentoControleAporte(tipoLancamentoControleAporteState.busca));

    form.setFieldsValue({ dataInicio: dayjs(lancamentoControleAporteState.busca.dataInicioTransacao), dataFim: dayjs(lancamentoControleAporteState.busca.dataFimTransacao) });
    if (persistedState.user.empresa !== null) {
      form.setFieldsValue({ idEmpresa: persistedState.user.empresa.idEmpresa });
      onChangeEmpresa(persistedState.user.empresa.idEmpresa);
    }
  }, []);

  const goCadastrar = () => {
    dispatch(setEntityLancamentoControleAporte({}));
    dispatch(setModalCadastrarLancamentoControleAporte(true));
  };

  const goEditar = (value: LancamentoControleAporteModel) => {
    dispatch(setEntityLancamentoControleAporte(value));
    dispatch(setModalCadastrarLancamentoControleAporte(true));
  };

  const closeModalCadastrar = () => {
    dispatch(setModalCadastrarLancamentoControleAporte(false));
  };

  const goDeletar = (value: LancamentoControleAporteModel) => {
    dispatch(setEntityLancamentoControleAporte(value));
    dispatch(setModalDeletarLancamentoControleAporte(true));
  };

  const closeModalDeletar = () => {
    dispatch(setModalDeletarLancamentoControleAporte(false));
  };

  const goConfirmarRecebimento = (value: LancamentoControleAporteModel) => {
    dispatch(setEntityLancamentoControleAporte(value));
    dispatch(setModalRecebimentoLancamentoControleAporte(true));
  };

  const closeModalRecebimento = () => {
    dispatch(setModalRecebimentoLancamentoControleAporte(false));
  };

  const onChangeEmpresa = (value: number) => {
    dispatch(setIdEmpresaPermissao(value));

    var busca: BuscarLancamentoControleAporteModel = { ...lancamentoControleAporteState.busca, idEmpresa: value };

    dispatch(setBuscaLancamentoControleAporte(busca));
    dispatch(listarSorteio(value.toString()));
    dispatch(buscarLancamentoControleAporte(busca));
  };

  const onChangeTipo = (value: number) => {
    var busca: BuscarLancamentoControleAporteModel = { ...lancamentoControleAporteState.busca, idTipoLancamentoControleAporte: value };

    dispatch(setBuscaLancamentoControleAporte(busca));
    dispatch(buscarLancamentoControleAporte(busca));
  };

  const onChangeDataInicio = (value: DatePickerProps["value"], dateString: string | string[]) => {
    var busca: BuscarLancamentoControleAporteModel = { ...lancamentoControleAporteState.busca, dataInicioTransacao: dayjs(value).toDate() };

    dispatch(setBuscaLancamentoControleAporte(busca));
    dispatch(buscarLancamentoControleAporte(busca));
  };

  const onChangeDataFim = (value: DatePickerProps["value"], dateString: string | string[]) => {
    var busca: BuscarLancamentoControleAporteModel = { ...lancamentoControleAporteState.busca, dataFimTransacao: dayjs(value).toDate() };

    dispatch(setBuscaLancamentoControleAporte(busca));
    dispatch(buscarLancamentoControleAporte(busca));
  };

  const onChangeSorteio = (value: number) => {
    var busca: BuscarLancamentoControleAporteModel = { ...lancamentoControleAporteState.busca, idSorteio: value === undefined ? null : value };

    dispatch(setBuscaLancamentoControleAporte(busca));
    dispatch(buscarLancamentoControleAporte(busca));
  };

  const items: ItemMenuAcoes[] = [
    {
      label: "Editar",
      key: "1",
      icon: <Icon.EditOutlined />,
      function: (item: any) => goEditar(item),
    },
    {
      label: "Remover",
      key: "2",
      icon: <Icon.DeleteOutlined />,
      function: (item: any) => goDeletar(item),
    },
  ];

  const itemsRecebimento: ItemMenuAcoes[] = [
    {
      label: "Confirmar Recebimento",
      key: "1",
      icon: <Icon.SnippetsOutlined />,
      function: (item: any) => goConfirmarRecebimento(item),
      disabled: (item: any) => item.idTipoLancamentoControleAporte !== 2,
    },
    {
      label: "Remover",
      key: "2",
      icon: <Icon.DeleteOutlined />,
      function: (item: any) => goDeletar(item),
      disabled: (item: any) => !item.lancamentoManual,
    },
  ];

  const columns: ColumnsType<LancamentoControleAporteModel> = [
    {
      title: "DATA LANÇAMENTO",
      dataIndex: "dataLancamento",
      align: "center",
      width: 150,
      render: (_, record) => {
        return <>{record.dataLancamento && dayjs(record.dataLancamento).format("DD/MM/YYYY")}</>;
      },
    },
    {
      title: "SORTEIO",
      dataIndex: "dataSorteio",
      align: "center",
      width: 150,
      render: (_, record) => {
        return <>{record.dataSorteio && dayjs(record.dataSorteio).format("DD/MM/YYYY")}</>;
      },
    },
    {
      title: "TIPO DE LANÇAMENTO",
      dataIndex: "denominacaoTipoLancamento",
      align: "center",
      width: 150,
    },
    {
      title: "VALOR",
      dataIndex: "valor",
      align: "center",
      width: 150,
      render: (_, record) =>
        record.es < 0 ? (
          <p style={{ color: "red", marginBottom: "0px" }}>{currencyBRL(record.valor * record.es)}</p>
        ) : (
          <p style={{ color: "blue", marginBottom: "0px" }}>{currencyBRL(record.valor)}</p>
        ),
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center",
      width: 75,
      render: (_, record) => <AcoesComponent record={record} items={record.lancamentoManual ? items : itemsRecebimento} />,
    },
  ];

  return (
    <Flex vertical>
      <Form layout="vertical" form={form} onFinish={goCadastrar}>
        <Row gutter={12} align="bottom">
          <Col span={19}>
            <Flex gap={12}>
              {persistedState.user.empresa === null && (
                <Form.Item
                  label="Empresa"
                  name="idEmpresa"
                  rules={[
                    {
                      required: true,
                      message: "Campo obrigatório",
                    },
                  ]}
                >
                  <Select
                    optionFilterProp="labelSearch"
                    placeholder="Selecione uma empresa"
                    loading={empresaState.loading}
                    onChange={onChangeEmpresa}
                    style={{ width: 300 }}
                    options={empresaState.list.map((a: EmpresaModel) => ({
                      value: a.id,
                      key: a.apelido,
                      label: (
                        <Flex justify="flex-start" align="center" gap={8} style={{ padding: "1px 0px" }}>
                          <div style={{ lineHeight: "0px" }}>{a.urlLogotipoPequeno && <Image width={25} height={25} style={{ lineHeight: "0px" }} src={a.urlLogotipoPequeno} preview={false} />}</div>
                          {a.apelido}
                        </Flex>
                      ),
                      labelSearch: a.apelido,
                    }))}
                  />
                </Form.Item>
              )}
              <Form.Item label="Data Inicial" name="dataInicio">
                <DatePicker onChange={onChangeDataInicio} format="DD/MM/YYYY" allowClear={false} style={{ width: 120 }} />
              </Form.Item>
              <Form.Item label="Data Fim" name="dataFim">
                <DatePicker onChange={onChangeDataFim} format="DD/MM/YYYY" allowClear={false} style={{ width: 120 }} />
              </Form.Item>
              <Form.Item label="Sorteio" name="idSorteio">
                <Select
                  allowClear
                  showSearch
                  optionFilterProp="label"
                  loading={sorteioState.loadingEmpresas}
                  onChange={onChangeSorteio}
                  style={{ width: 120 }}
                  options={sorteioState.listSorteioEmpresas.map((a: DetalhesSorteioModel) => ({
                    value: a.idSorteio,
                    label: dayjs(a.dataSorteio).format("DD/MM/YYYY"),
                  }))}
                />
              </Form.Item>
              <Form.Item label="Tipo Lançamento" name="idTipoLancamentoControleAporte">
                <Select
                  onChange={onChangeTipo}
                  allowClear
                  style={{ width: 220 }}
                  loading={tipoLancamentoControleAporteState.loading}
                  options={tipoLancamentoControleAporteState.list.map((a: any) => ({
                    value: a.id,
                    label: a.denominacao,
                  }))}
                />
              </Form.Item>
            </Flex>
          </Col>
          <Col span={5}>
            <Flex justify="end" gap={12}>
              <ButtonComponent htmlType="submit">NOVO RECEBIMENTO</ButtonComponent>
            </Flex>
          </Col>
        </Row>
      </Form>
      <TableComponent data={lancamentoControleAporteState.list} columns={columns} loading={lancamentoControleAporteState.loading} rowKey="idLancamentoControleAporte" />
      <Modal
        title={editar ? "EDITAR RECEBIMENTO" : "NOVO RECEBIMENTO"}
        centered
        width={600}
        open={lancamentoControleAporteState.modalCadastrar}
        onCancel={closeModalCadastrar}
        footer={null}
        destroyOnHidden
      >
        <CadastroLancamentoControleAporte />
      </Modal>
      <Modal title="REMOVER LANÇAMENTO" centered width={350} open={lancamentoControleAporteState.modalDeletar} onCancel={closeModalDeletar} footer={null} destroyOnHidden>
        <MensagemModal
          text="Deseja remover o lançamento de controle de aporte?"
          action={deletarLancamentoControleAporte({ value: lancamentoControleAporteState.entity.idLancamentoControleAporte, busca: lancamentoControleAporteState.busca })}
          close={setModalDeletarLancamentoControleAporte(false)}
        />
      </Modal>
      <Modal title="CONFIRMAR RECEBIMENTO" centered width={600} onCancel={closeModalRecebimento} open={lancamentoControleAporteState.modalRecebimento} footer={null} destroyOnHidden>
        <ConfirmarRecebimento />
      </Modal>
    </Flex>
  );
};

export default LancamentoControleAporte;
